/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Pit1_TInputs */

const en_minifier_pit1_t = /** @type {(inputs: Minifier_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minified is not compressed`)
};

const ko_minifier_pit1_t = /** @type {(inputs: Minifier_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축은 압축 파일이 아닙니다`)
};

const ja_minifier_pit1_t = /** @type {(inputs: Minifier_Pit1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮は圧縮ファイルではありません`)
};

/**
* | output |
* | --- |
* | "Minified is not compressed" |
*
* @param {Minifier_Pit1_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_pit1_t = /** @type {((inputs?: Minifier_Pit1_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Pit1_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_pit1_t(inputs)
	if (locale === "ko") return ko_minifier_pit1_t(inputs)
	return ja_minifier_pit1_t(inputs)
});